import React from "react";
import FormationBuilderPage from "../FormationBuilderPage";

const TechnicienBancEssai = () => {
  const technicienBancEssaiProgram = [
    {
      title: "Animation de réunion",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Rédaction de synthèse",
      img: "/assets/images/icon/tuyaux.svg",
    },
    {
      title: "Prise de parole",
      img: "/assets/images/icon/work.svg",
    },
    {
      title: "Management de projet",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Mécanique générale",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Mécanique des Fluides",
      img: "/assets/images/icon/work-women.svg",
    },
    {
      title: "Métrologie",
      img: "/assets/images/icon/redaction.svg",
    },
    {
      title: "Electrotechnique",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Modélisation et commande des systèmes",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Electronique de puissance",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "Thermique",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Pneumatique/hydraulique",
      img: "/assets/images/icon/network-card.svg",
    },
    {
      title: "Introduction et découverte du contrôle moteur",
      img: "/assets/images/icon/component-card.svg",
    },
    {
      title: "Présentation du moteur et de ses organes",
      img: "/assets/images/icon/setting.svg",
    },
    {
      title:
        "Contrôle du couple et des émissions de moteurs à allumage commandé ",
      img: "/assets/images/icon/light.svg",
    },
    {
      title: "Contrôle du couple et des émissions de moteurs diesel",
      img: "/assets/images/icon/balance.svg",
    },
    {
      title: "Fonctions transversales du contrôle moteur",
      img: "/assets/images/icon/fiche.svg",
    },
    {
      title: "Programmation Moteur",
      img: "/assets/images/icon/rule.svg",
    },
    {
      title: "Reporting",
      img: "/assets/images/icon/redaction.svg",
    },
    {
      title: "Méthode 5S",
      img: "/assets/images/icon/setting.svg",
    },
    {
      title: "Projet final",
      img: "/assets/images/icon/light.svg",
    },
  ];

  return (
    <FormationBuilderPage
      category="Aéronautique"
      titleColor="#2424FF"
      title="Technicien Banc d’Essai"
      duration={11}
      description={
        <React.Fragment>
          <p>
            Grâce au partenariat entre Liora et SEGULA Technologies, rejoignez
            un groupe d’ingénierie mondiale à forte croissance en tant que
            Technicien Banc d’Essai, après une formation accélérée de 11
            semaines.
          </p>
          <p>
            Impression 3D, réalité augmentée, véhicule autonome, usine du
            futur... rythment le quotidien de nos 13 000 ingénieux
            collaborateurs, pourquoi pas le vôtre ?
          </p>
        </React.Fragment>
      }
      image="/assets/images/home/aeronautique.png"
      program={technicienBancEssaiProgram}
      formId="67c7583f-277a-4925-876a-95d201130c19"
    />
  );
};

export default TechnicienBancEssai;
